<template>
    <div class="container">
        <md-dialog :md-active.sync="modEditarTasa" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoTasa }}</pre> -->
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tipoTasa}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <!-- <select v-model="infoTasa[0].tipo_tasa" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipoTasa in listTipoTasa" :key="tipoTasa.id" :value="tipoTasa.tipo_tasa">{{ tipoTasa.descripcion }}</option>
                        </select> -->
                        <h4>{{ nameTipoTasa(infoTasa[0].tipo_tasa) }}</h4>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valor}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoTasa[0].valor" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.vigencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="infoTasa[0].vigencia" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="7" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <md-button class="md-primary" @click="guardarTasa">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteTasa" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>

import TipoTasas from '../../../services/TipoTasas'
import Tasa from '../../../services/Tasas';
import InacticaItem from '../../utils/InacticaItem.vue';

export default {
    name : 'Editar',
    props : ['modEditarTasa','infoTasa'],
    components : {InacticaItem},
    data: () => ({
        listTipoTasa : [],
        deleteTasa : false,
        idTasa : null
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Editar tasa',
                    delete : 'Eliminar',
                    save : 'Guardar',
                    close : 'Cerrar',
                    select : 'Seleccione...',
                    tipoTasa : 'Tipo tasa',
                    valor : 'Valor',
                    vigencia : 'Vigencia',
                }
            }else{
                return {
                    title : 'Edit rate',
                    delete : 'Delete',
                    save : 'Save',
                    close : 'Close',
                    select : 'Select...',
                    tipoTasa : 'Rate type',
                    valor : 'Worth',
                    vigencia : 'Validity',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalDelet(){
            this.deleteTasa = false
        },
        guardarTasa(){
            // console.log('guardarTasa');
            const dataForm = [
                this.infoTasa[0].tipo_tasa,
                this.infoTasa[0].valor,
                this.infoTasa[0].vigencia
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'id' : this.infoTasa[0].id,
                    'tipo_tasa' : this.infoTasa[0].tipo_tasa,
                    'valor' : this.infoTasa[0].valor,
                    'vigencia' : this.infoTasa[0].vigencia,
                    'idUser' : this.$store.state.userId
                }

                Tasa.updateTasaById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()                    
                    }
                })
                .catch((error) => { console.log(error) })
            }
        },
        eliminaRegistro(){
            this.idTasa = this.infoTasa[0].id
            this.deleteTasa = true
        },
        confirmInactivate(){
            Tasa.deleteTasa(this.idTasa)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()                
                }
            })
            .catch((error) => error)
        },
        nameTipoTasa(tipTasa){
            // console.log(tipTasa);
            let name = this.listTipoTasa.find((tipoTasa) => tipoTasa.tipo_tasa == tipTasa)
            // console.log(name);
            return name.descripcion
        }
    },
    mounted(){
        TipoTasas.getAllTipoTasas()
        .then((res) => {
            // console.log(res.data.listTipoTasas);
            this.listTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => { console.log(err) })
    }
}
</script>

<style>

</style>